import React from 'react';
import { translate } from 'core/services/localization';
import { getCustomIconUrl } from 'core/services/iconService';

export default function CustomIconIndicator({ moduleNwid, tooltip, icon }) {
  return <img className='custom-icon-indicator' title={translate(tooltip)} src={getCustomIconUrl(moduleNwid, icon)} />;
}